import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { EquipmentActionName } from '@frontend/equipment/types';
import React from 'react';

import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import useEquipmentActionSelect from './equipment-action-select.controller';

const ID = 'equipment-action-select';
export interface EquipmentActionSelectProps extends Omit<SelectInputV2Props<EquipmentActionName>, 'options'> {
    subset?: string[];
    dispatch?: ThunkDispatch<any, any, Action>;
}

export const EquipmentActionSelect = (props: EquipmentActionSelectProps) => {
    const viewProps = useEquipmentActionSelect(props);

    return (
        <SelectInputV2<EquipmentActionName>
            {...props}
            id={ID + props.id}
            label={props.label || 'Equipment action'}
            options={viewProps.options}
        />
    );
};

export default EquipmentActionSelect;
